<template>
  <div class="qyxxbgDiaLogBody">
    <div class="_title" style="width: 190px">
      <p class="_title_info" style="margin: 0 auto">法人/经营者信息变更</p>
    </div>
    <div class="uploadImage">
      <div class="left">
        <div class="uploadLeftContainer" style="">
          <el-image
            :preview-src-list="srcList"
            :src="imageUrlOface"
            style="width: 204px; height: 140px"
            class="avatar"
          />
        </div>
        <div class="instruction" style="text-align: center">证件人像面</div>
      </div>
      <div v-if="idCard == '1'" style="margin-left: 70px">
        <div class="uploadRightContainer">
          <el-image
            :preview-src-list="srcList"
            :src="imageUrlOfZG"
            style="width: 204px; height: 140px"
            class="avatar"
          />
        </div>
        <div class="instruction" style="text-align: center">证件国徽面</div>
      </div>
    </div>
    <div class="_sfzjInfo">
      <div class="_sfzjTitle">身份证件信息</div>
      <div class="_sfzjBd">
        <el-form
          disabled
          label-position="right"
          class="_sfzjForm"
          label-width="140px"
          :model="frBgjlDtoFu"
        >
          <el-form-item label="姓名:">
            <el-input
              v-model="frBgjlDtoFu.xm.afterValue"
              placeholder="请输入姓名"
            />
            <el-popover
              v-show="frBgjlDtoFu.xm.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + frBgjlDtoFu.xm.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item label="证件类型:">
            <el-select
              v-model="frBgjlDtoFu.zjlx.afterValue"
              style="width: 100%"
              placeholder="请选择证件类型"
            >
              <el-option
                v-for="(item, index) in zjlxList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-popover
              v-show="frBgjlDtoFu.zjlx.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + frBgjlDtoFu.zjlx.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item v-if="idCard == '4'" label="证件名称:">
            <el-select
              v-model="frBgjlDtoFu.qtzj.afterValue"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in zjNameOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-popover
              v-show="frBgjlDtoFu.qtzj.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + frBgjlDtoFu.qtzj.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item label="性别:">
            <el-select
              v-model="frBgjlDtoFu.xb.afterValue"
              style="width: 100%"
              placeholder="请选择性别"
            >
              <el-option
                v-for="(item, index) in sexOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-popover
              v-show="frBgjlDtoFu.xb.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + xbName"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item label="证件号码:">
            <el-input
              v-model="frBgjlDtoFu.zjhm.afterValue"
              placeholder="请输入证件号码"
            />
            <el-popover
              v-show="frBgjlDtoFu.zjhm.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + frBgjlDtoFu.zjhm.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item label="民族:">
            <el-select
              v-model="frBgjlDtoFu.mz.afterValue"
              style="width: 100%"
              placeholder="请选择民族"
            >
              <el-option
                v-for="(item, index) in mzOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-popover
              v-show="frBgjlDtoFu.mz.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + mzName"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item label="出生日期:">
            <el-date-picker
              v-model="frBgjlDtoFu.sr.afterValue"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择出生日期"
            />
            <el-popover
              v-show="frBgjlDtoFu.sr.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + frBgjlDtoFu.sr.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item v-if="idCard == '1'" label="籍贯:">
            <el-input
              v-model="frBgjlDtoFu.jgLabel.afterValue"
              placeholder="请输入行政区划"
            />
            <el-popover
              v-show="frBgjlDtoFu.jgLabel.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + frBgjlDtoFu.jgLabel.beforeValue"
            >
            </el-popover>
           <!-- <el-cascader
              v-model="jgNum"
              style="width: 100%"
              clearable
              placeholder=""
              :props="jgProps"
              filterable
            />-->
            <!-- <el-popover
              v-show="frBgjlDtoFu.sjjyd.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + frBgjlDtoFu.sjjyd.beforeValue"
            >
              <img src="@/assets/img/tishiNew.png" alt="" slot="reference" />
            </el-popover> -->
          </el-form-item>
          <el-form-item label="有效期限:">
            <el-date-picker
              v-model="frBgjlDtoFu.yxqxDate"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
            <el-popover
              v-show="
                frBgjlDtoFu.yxqxJs.isChange || frBgjlDtoFu.yxqxKs.isChange
              "
              placement="top-start"
              width="200"
              trigger="hover"
              :content="
                '修改前内容:' +
                  frBgjlDtoFu.yxqxKs.beforeValue +
                  '~' +
                  frBgjlDtoFu.yxqxJs.beforeValue
              "
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item label="发证机关:">
            <el-input
              v-model="frBgjlDtoFu.fzjg.afterValue"
              placeholder="请输入机关名称"
            />
            <el-popover
              v-show="frBgjlDtoFu.fzjg.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + frBgjlDtoFu.fzjg.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="_qtxxInfo">
      <div class="_qtxxTitle">其他信息</div>
      <div class="_qtxxBd">
        <el-form
          label-position="right"
          disabled
          class="_qtxxForm"
          label-width="140px"
          :model="frBgjlDtoFu"
        >
          <el-form-item label="办公电话:">
            <el-input
              v-model="frBgjlDtoFu.bgdh.afterValue"
              placeholder="请输入办公电话 例:010-86551122"
            />
            <el-popover
              v-show="frBgjlDtoFu.bgdh.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + frBgjlDtoFu.bgdh.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item label="手机号码:">
            <el-input
              v-model="frBgjlDtoFu.sjhm.afterValue"
              placeholder="请输入手机号码"
            />
            <el-popover
              v-show="frBgjlDtoFu.sjhm.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + frBgjlDtoFu.sjhm.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item class="jydItem" style="width: 100%" label="实际住址:">
            <el-input
              v-model="frBgjlDtoFu.sjzz.afterValue"
              placeholder="请输入实际住址"
            />
            <el-popover
              v-show="frBgjlDtoFu.sjzz.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + frBgjlDtoFu.sjzz.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { returnShowPic, getkv } from '@/assets/js/common.js'
import { getXzqTree, getXzqTreeS } from '@/assets/js/step2.js'
export default {
  props: {
    frBgjlDto: Object
  },
  data() {
    return {
      jgProps: {
        lazy: true, // 开启懒加载
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            }
          }, 500)
        }
      },
      zjlxList: [
        { label: '身份证', value: '1' },
        { label: '其他证件', value: '4' }
      ], // 证件类型下拉
      mzName: '',
      xbName: '',
      idCard: '1', // 当前证件类型
      srcList: [], // 大图列表
      // 性别下拉
      sexOptions: [
        // 性别下拉
        {
          label: '男',
          value: '0'
        },
        {
          label: '女',
          value: '1'
        },
        {
          label: '未知',
          value: '2'
        }
      ],
      zjNameOptions: [], // 证件名称
      mzOptions: [], // 民族下拉
      jgNum: [], // 籍贯数据
      // jiekou
      // 校验规则
      imageUrlOfZG: '', // 证件国徽面
      imageUrlOface: '' // 证件人像面
    }
  },
  computed: {
    frBgjlDtoFu: {
      get() {
        return this.frBgjlDto
      },
      set(val) {
        this.$emit('getfrBgjlDto', val)
      }
    }
  },
  watch: {
    'frBgjlDtoFu.zjlx.afterValue'(newValue, oldValue) {
      this.idCard = newValue
    },
    frBgjlDtoFu(newValue, oldValue) {
      this.jgNum = !newValue.jg.afterValue
        ? []
        : newValue.jg.afterValue.split(',').map(Number)
      /* 时间选择器赋值回显 */
      if (
        newValue.yxqxJs.afterValue != '' &&
        newValue.yxqxJs.afterValue != null
      ) {
        this.frBgjlDtoFu.yxqxDate = [
          newValue.yxqxKs.afterValue,
          newValue.yxqxJs.afterValue
        ]
      }
      /* 证件类型回显 */
      if (
        newValue.zjzpZm.afterValue !== '' &&
        newValue.zjzpZm.afterValue !== null
      ) {
        const baseImgUrl = returnShowPic()
        this.imageUrlOface = baseImgUrl + newValue.zjzpZm.afterValue
        this.srcList.push(this.imageUrlOface)
      }
      if (
        newValue.zjzpFm.afterValue !== '' &&
        newValue.zjzpFm.afterValue !== null
      ) {
        const baseImgUrl = returnShowPic()
        this.imageUrlOfZG = baseImgUrl + newValue.zjzpFm.afterValue
        this.srcList.push(this.imageUrlOfZG)
      }
      this.sexOptions.forEach((element) => {
        if (newValue.xb.beforeValue === element.value) {
          this.xbName = element.label
        }
      })
      this.mzOptions.forEach((element) => {
        if (newValue.mz.beforeValue === element.value) {
          this.mzName = element.label
        }
      })
    }
  },
  created() {},
  mounted() {
    this.initFr()
  },
  beforeDestroy() {},
  methods: {
    initFr() {
      // 民族
      getkv('yzd_mz').then((e) => {
        this.mzOptions = e.data.data
      })
      // 证件名称
      getkv('yzd_ry_zjmc').then((e) => {
        this.zjNameOptions = e.data.data
      })
    }
  }
}
</script>
<style lang="less" scoped>
.qyxxbgDiaLogBody {
  width: 90%;
  max-width: 1200px;
  margin: 10px auto 0px auto;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  align-items: center;
  position: relative;
  ._title {
    width: 120px;
    margin-top: 50px;
    ._title_info {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
  }
  .uploadImage {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    width: 598px;
    height: 160px;
    border-radius: 3px;
    box-sizing: border-box;
    .uploadLeftContainer {
      position: relative;
    }
    .uploadRightContainer {
      position: relative;
    }
    .deleteUpload {
      width: 25px;
      height: 25px;
      position: absolute;
      right: 0;
      top: 15px;
      cursor: pointer;
    }
  }
  ._sfzjInfo {
    width: 85%;
    margin-top: 69px;
    ._sfzjTitle {
      width: 96px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
    ._sfzjBd {
      margin: 30px 0px;
      ._sfzjForm {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          margin-right: 0;
          width: 45%;
          /deep/.el-form-item__content {
            display: flex !important;
          }
        }
      }
    }
  }
  ._qtxxInfo {
    width: 85%;
    ._qtxxTitle {
      width: 96px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
    ._qtxxBd {
      margin: 30px 0px;
      ._qtxxForm {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          margin-right: 0;
          width: 45%;
          /deep/.el-form-item__content {
            display: flex !important;
          }
        }
      }
    }
  }
}
</style>
